var _g;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
import { forwardRef } from "react";
const SvgIcFaceRecognition = (_ref, ref) => {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "48px",
    height: "48px",
    viewBox: "0 0 48 48",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "51387411-E7F5-43B2-9DB2-04504648AD3B") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "POC",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "00.00.01-Onboarding",
    transform: "translate(-24.000000, -444.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "face_recognition_hi",
    transform: "translate(24.000000, 444.000000)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "bg",
    fillOpacity: 0,
    fill: "#D8D8D8",
    x: 0,
    y: 0,
    width: 48,
    height: 48
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8,8 L8,13 C8,13.5522847 7.55228475,14 7,14 C6.44771525,14 6,13.5522847 6,13 L6,7 C6,6.44771525 6.44771525,6 7,6 L13,6 C13.5522847,6 14,6.44771525 14,7 C14,7.55228475 13.5522847,8 13,8 L8,8 Z",
    id: "Shape",
    fill: "#E60000",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group",
    opacity: 0.12,
    transform: "translate(6.000000, 6.707500)",
    fill: "#000000",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1,6.71 C0.44771525,6.71 0,6.26228475 0,5.71 L0,6.2925 C0,6.84478475 0.44771525,7.2925 1,7.2925 C1.55228475,7.2925 2,6.84478475 2,6.2925 L2,5.71 C2,6.26228475 1.55228475,6.71 1,6.71 Z",
    id: "Shape"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7,0.71 L2,0.71 L2,1.2925 L7,1.2925 C7.55228475,1.2925 8,0.84478475 8,0.2925 C7.99845391,0.193210753 7.98245257,0.0946762294 7.9525,0 C7.82521955,0.420053388 7.43890911,0.708011829 7,0.71 Z",
    id: "Shape"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M8,40 L13,40 C13.5522847,40 14,40.4477153 14,41 C14,41.5522847 13.5522847,42 13,42 L7,42 C6.44771525,42 6,41.5522847 6,41 L6,35 C6,34.4477153 6.44771525,34 7,34 C7.55228475,34 8,34.4477153 8,35 L8,40 Z",
    id: "Shape",
    fill: "#E60000",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13,41.4575 L7,41.4575 C6.44771525,41.4575 6,41.0097847 6,40.4575 L6,41 C6,41.5522847 6.44771525,42 7,42 L13,42 C13.5522847,42 14,41.5522847 14,41 C13.9988871,40.9084248 13.9845731,40.8174888 13.9575,40.73 C13.8360751,41.1587511 13.4456088,41.4554239 13,41.4575 Z",
    id: "Shape",
    fill: "#000000",
    fillRule: "nonzero",
    opacity: 0.12
  }), /*#__PURE__*/React.createElement("path", {
    d: "M40,8 L35,8 C34.4477153,8 34,7.55228475 34,7 C34,6.44771525 34.4477153,6 35,6 L41,6 C41.5522847,6 42,6.44771525 42,7 L42,13 C42,13.5522847 41.5522847,14 41,14 C40.4477153,14 40,13.5522847 40,13 L40,8 Z",
    id: "Shape",
    fill: "#E60000",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group",
    opacity: 0.12,
    transform: "translate(34.000000, 6.707500)",
    fill: "#000000",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M7,6.71 C7.55228475,6.71 8,6.26228475 8,5.71 L8,6.2925 C8,6.84478475 7.55228475,7.2925 7,7.2925 C6.44771525,7.2925 6,6.84478475 6,6.2925 L6,5.71 C6,6.26228475 6.44771525,6.71 7,6.71 Z",
    id: "Shape"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1,0.71 L6,0.71 L6,1.2925 L1,1.2925 C0.44771525,1.2925 0,0.84478475 0,0.2925 C0.00154609366,0.193210753 0.0175474265,0.0946762294 0.0475,0 C0.174780445,0.420053388 0.561090889,0.708011829 1,0.71 Z",
    id: "Shape"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M40,40 L40,35 C40,34.4477153 40.4477153,34 41,34 C41.5522847,34 42,34.4477153 42,35 L42,41 C42,41.5522847 41.5522847,42 41,42 L35,42 C34.4477153,42 34,41.5522847 34,41 C34,40.4477153 34.4477153,40 35,40 L40,40 Z",
    id: "Shape",
    fill: "#E60000",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M35,41.4575 L41,41.4575 C41.5522847,41.4575 42,41.0097847 42,40.4575 L42,41 C42,41.5522847 41.5522847,42 41,42 L35,42 C34.4477153,42 34,41.5522847 34,41 C34.0011129,40.9084248 34.0154269,40.8174888 34.0425,40.73 C34.1639249,41.1587511 34.5543912,41.4554239 35,41.4575 Z",
    id: "Shape",
    fill: "#000000",
    fillRule: "nonzero",
    opacity: 0.12
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    fill: "#EBEBEB",
    fillRule: "nonzero",
    cx: 23.9575,
    cy: 24,
    r: 13
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group",
    opacity: 0.06,
    transform: "translate(10.957500, 23.750000)",
    fill: "#000000",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M13,12.75 C5.91680691,12.7513099 0.136215133,7.08188333 0,0 C0,0.0825 0,0.165 0,0.25 C0,7.42970175 5.82029825,13.25 13,13.25 C20.1797017,13.25 26,7.42970175 26,0.25 C26,0.165 26,0.0825 26,0 C25.8637849,7.08188333 20.0831931,12.7513099 13,12.75 Z",
    id: "Shape"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M28.7326834,27.1634949 C28.91853,26.9592508 29.234761,26.9443368 29.4390051,27.1301834 C29.6432492,27.31603 29.6581632,27.632261 29.4723166,27.8365051 C28.1333635,29.3080049 26.2646109,30.1872155 24.277307,30.280653 C22.2900031,30.3740904 20.3470008,29.6740978 18.8777644,28.336419 C18.73233,28.2053485 18.5923114,28.0680225 18.4577314,27.9244706 C18.2688663,27.7230144 18.2790733,27.4065965 18.4805294,27.2177314 C18.6819856,27.0288663 18.9984035,27.0390733 19.1872686,27.2405294 C19.3026886,27.3636441 19.42267,27.4813182 19.5491119,27.5952806 C20.8240763,28.7560753 22.5080116,29.3627356 24.2303417,29.2817564 C25.9526717,29.2007773 27.5722573,28.4387948 28.7326834,27.1634949 Z",
    id: "fab81382_f57f_4f72_b34a_4a02947b0636",
    fill: "#4A4D4E",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27.8325,21.5 C28.3675,21.5 28.8325,21.95 29.06,22.605 C29.0865265,22.6818328 29.157417,22.7345672 29.2386324,22.7378821 C29.3198478,22.7411971 29.3948001,22.6944154 29.4275,22.62 C29.607611,22.1701512 29.6984661,21.6895533 29.695,21.205 C29.695,19.6825 28.86,18.455 27.8325,18.455 C26.805,18.455 25.97,19.6875 25.97,21.205 C25.9669962,21.6892765 26.0569564,22.1696299 26.235,22.62 C26.2676999,22.6944154 26.3426522,22.7411971 26.4238676,22.7378821 C26.505083,22.7345672 26.5759735,22.6818328 26.6025,22.605 C26.835,21.96 27.2975,21.5 27.8325,21.5 Z",
    id: "Shape",
    fill: "#4A4D4E",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.3625,21.5 C20.8975,21.5 21.3625,21.95 21.59,22.605 C21.6165265,22.6818328 21.687417,22.7345672 21.7686324,22.7378821 C21.8498478,22.7411971 21.9248001,22.6944154 21.9575,22.62 C22.137611,22.1701512 22.2284661,21.6895533 22.225,21.205 C22.225,19.6825 21.39,18.455 20.3625,18.455 C19.335,18.455 18.5,19.6925 18.5,21.215 C18.4969962,21.6992765 18.5869564,22.1796299 18.765,22.63 C18.7976999,22.7044154 18.8726522,22.7511971 18.9538676,22.7478821 C19.035083,22.7445672 19.1059735,22.6918328 19.1325,22.615 C19.365,21.96 19.8275,21.5 20.3625,21.5 Z",
    id: "Shape",
    fill: "#4A4D4E",
    fillRule: "nonzero"
  }))))));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgIcFaceRecognition);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/ic_face_recognition.e7b2cc9046b851e8f787edc0fe39a267.svg";